import { useEffect, useState } from "react";
import ComboBox from "../../components/controls/ComboBox/ComboBox";
import { NameValuePair } from "../../models/interfaces";
import reportService from "../../services/reportService";
import DateTimePicker from "../../components/controls/DateTimePicker/DateTimePicker";
import FormCommand from "../../components/controls/FormCommand";

export interface GenerateManagementReportFormProps {}

function GenerateManagementReportForm(
  props: GenerateManagementReportFormProps
) {
  const [reports, setReports] = useState<NameValuePair[]>();

  const fetchReports = async () => {
    const res = await reportService.getReports();
    if (res.status) {
      setReports(
        res.data?.map((d) => {
          const item: NameValuePair = {
            id: d.id,
            name: d.name,
          };

          return item;
        })
      );
    }
  };

  useEffect(() => {
    fetchReports();
  }, []);

  return (
    <div className="row">
      <div className="col-7">
        <h4>Generate Report</h4>
        <ComboBox
          id="reportType"
          text="Select Report"
          items={reports}
          prompt="Select Management Report"
        />
        <div className="row">
          <div className="col">
            <DateTimePicker id="startDate" text="Start Date" type="date" />
          </div>
          <div className="col">
            <DateTimePicker id="endDate" text="End Date" type="date" />
          </div>
        </div>

        <FormCommand />
      </div>
    </div>
  );
}

export default GenerateManagementReportForm;
